var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBluePlusBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.5H13V19.5H11V13.5H5V11.5H11V5.5H13V11.5H19V13.5Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBluePlusBtn);
export default __webpack_public_path__ + "static/media/AddBluePlusBtn.0376256c878941dbb9139c30af3995fb.svg";
export { ForwardRef as ReactComponent };